export type RangeMode = 'equal' | 'range' | 'periods';

interface RangeValues {
  equal?: any;
  from?: any;
  to?: any;
}

interface RangeDisplayOptions {
  compareValues?: (a: any, b: any) => boolean;
}

export function formatRangeDisplayValue(
  mode: RangeMode,
  values: RangeValues,
  formatValue: (value: any) => string,
  options: RangeDisplayOptions = {}
): string {
  const compareValues = options.compareValues || ((a, b) => a === b);

  if (mode === 'equal') {
    const val = values.equal;
    if (val === null || val === undefined || val === '') {
      return '';
    }
    return `= ${formatValue(val)}`;
  }

  const from = values.from;
  const to = values.to;

  if (
    (from === null || from === undefined || from === '') &&
    (to === null || to === undefined || to === '')
  ) {
    return '';
  }

  const fromStr = formatValue(from);
  const toStr = formatValue(to);

  if (fromStr && toStr) {
    if (compareValues(from, to)) {
      return `= ${fromStr}`;
    }
    return `${fromStr} - ${toStr}`;
  }
  if (fromStr) {
    return `>= ${fromStr}`;
  }
  if (toStr) {
    return `<= ${toStr}`;
  }

  return '';
}
